import { useCallback } from 'react'
import { requestCreateSiteEcoSystem, requestUpdateSiteEcoSystem } from 'api/ecoSystem'

const useEcosystemPersistence = ({ ecosystemId, siteId, siteHistoryId, updateEcoSystem, getEcosystems }) => {
  const createAndUpdate = useCallback(async (payload) => {
    const createdEcosystem = await requestCreateSiteEcoSystem(siteId, siteHistoryId)
    const updatedEcoSystem = await requestUpdateSiteEcoSystem(createdEcosystem.id, siteHistoryId, payload)
    updateEcoSystem(updatedEcoSystem)
    await getEcosystems()
  }, [getEcosystems, siteHistoryId, siteId, updateEcoSystem])

  const persistField = useCallback((payload) => {
    if (ecosystemId === '') {
      return createAndUpdate(payload)
    }
    return requestUpdateSiteEcoSystem(ecosystemId, siteHistoryId, payload).then((updatedEcoSystem) => {
      updateEcoSystem(updatedEcoSystem)
      getEcosystems()
    })
  }, [createAndUpdate, ecosystemId, getEcosystems, siteHistoryId, updateEcoSystem])

  return { createAndUpdate, persistField }
}

export default useEcosystemPersistence

